import { optimisticTranslate } from '@i18n';

import { getAttributeFromUser } from '@framework/members';
import { isWindowDefined } from '@framework/utils';

const TOKEN = '7fca8fa1-9815-4fb9-a5a0-e6b265bf4457';
const HOST = 'https://wchat.freshchat.com';

export const buildFreshChatUser = (loggedMember, roomName) => {
    const getAttribute = getAttributeFromUser(loggedMember);
    return {
        email: getAttribute('email'),
        firstName: getAttribute('firstName'),
        lastName: getAttribute('lastName'),
        phone: getAttribute('phone'),
        locale: getAttribute('language'),
        meta: {
            Room: roomName,
            Role: getAttribute('role'),
            'Member ID': getAttribute('id'),
            'App Language': getAttribute('language')
        }
    };
};

export const updateFreshChatUser = (data) => {
    window.fcWidget?.user.update(data);
};

export const initFreshChat = (settings) => {
    const { meta, ...rest } = settings;
    window.fcWidget.init({
        ...(rest ?? {}),
        token: TOKEN,
        host: HOST,
        meta: {
            ...meta
        },
        config: {
            eagerLoad: true,
            headerProperty: {
                hideChatButton: true,
                backgroundColor: '#572FD0',
                foregroundColor: '#ffffff'
            },
            cssNames: {
                widget: 'fc_frame'
            },
            content: {
                placeholders: {
                    search_field: optimisticTranslate('Search'),
                    reply_field: optimisticTranslate('Reply'),
                    csat_reply: optimisticTranslate('Enter your comments here')
                },
                actions: {
                    csat_yes: optimisticTranslate('Yes'),
                    csat_no: optimisticTranslate('No'),
                    push_notify_yes: optimisticTranslate('Yes'),
                    push_notify_no: optimisticTranslate('No'),
                    tab_faq: optimisticTranslate('Knowledge'),
                    tab_chat: optimisticTranslate('Message'),
                    csat_submit: optimisticTranslate('Submit answer')
                },
                headers: {
                    chat: optimisticTranslate('Chat with us'),
                    chat_help: optimisticTranslate('Reach out to us if you have any questions'),
                    faq: optimisticTranslate('Knowledge Base'),
                    faq_help: optimisticTranslate('Browse our faqs'),
                    faq_not_available: optimisticTranslate('No FAQS'),
                    faq_search_not_available: optimisticTranslate(
                        'No FAQS available for {{query}}'
                    ),
                    faq_useful: optimisticTranslate('FAQS is useful'),
                    faq_thankyou: optimisticTranslate('Thanks for feedback'),
                    faq_message_us: optimisticTranslate('Message Us For FAQs'),
                    push_notification: optimisticTranslate(
                        'Do you want to be notified about new messages?'
                    ),
                    csat_question: optimisticTranslate('Did we address your question?'),
                    csat_yes_question: optimisticTranslate(
                        'How satisfied are you with our support?'
                    ),
                    csat_no_question: optimisticTranslate('What was lacking in our response?'),
                    csat_thankyou: optimisticTranslate('Thanks for the response'),
                    csat_rate_here: optimisticTranslate('Give your rating here'),
                    channel_response: {
                        offline: optimisticTranslate('We are currently away'),
                        online: {
                            minutes: {
                                one: optimisticTranslate('You will get a reply in a minute'),
                                more: optimisticTranslate(
                                    'You will get a reply in {!time!} minutes'
                                )
                            },
                            hours: {
                                one: optimisticTranslate('You will get a reply in a hour'),
                                more: optimisticTranslate('You will get a reply in {!time!} hours')
                            }
                        }
                    }
                }
            }
        }
    });
};

export const initFreshChatWithoutUser = (language) => {
    return initFreshChat({
        locale: language,
        meta: {
            'App Language': language
        }
    });
};

export const openFreshChat = ({ chatOrFAQ, onOpen }) => {
    const freshchatWidget = isWindowDefined() && window.fcWidget;
    if (freshchatWidget) {
        const showFAQOnOpen = chatOrFAQ === 'FAQ';
        const hideFAQ = chatOrFAQ === 'chat';
        freshchatWidget.setConfig({
            showFAQOnOpen,
            hideFAQ
        });
        freshchatWidget.open();
        freshchatWidget.on('widget:opened', () => {
            onOpen();
            freshchatWidget?.off('widget:opened', onOpen);
        });
    }
};

export const getFreshchatWidget = () => {
    return window.fcWidget;
};

export const loadFreshchatScript = () => {
    const id = 'freshchat-lib';
    if (document.getElementById(id) || window.fcWidget) {
        return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    document.head.appendChild(script);
    script.src = 'https://wchat.freshchat.com/js/widget.js';
    script.id = id;
};

export const logoutFreshChat = () => {
    const freshchatWidget = isWindowDefined() && getFreshchatWidget();

    if (freshchatWidget) {
        freshchatWidget?.user?.clear();
    }
};
